import { TrackingService } from './../../../services/tracking-service/tracking.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Host, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil, timeout } from 'rxjs/operators';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { MarketplaceFilterService } from 'src/app/services/componentServices/marketplace-filter-service/marketplace-filter.service';
import { MarketPlaceSideFilterComponent } from '../../marketplace/subcomponents/marketplace-side-filter/market-place-side-filter.component';
import { ProviderInterface } from './../../../model/user/provider-interface';
import { MarketplaceService } from 'src/app/services/dataServices/marketplace-service/marketplace.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    loggedIn = false;
    activeProvider: ProviderInterface[];
    login_activated = false;
    headerText$: Observable<String>;
    queryParams: Params = null;
    private destroy$ = new Subject<void>();
    isHandset$: Observable<boolean> = this.breakpointObserver
        .observe(Breakpoints.Handset)
        .pipe(
            map((result) => result.matches),
            shareReplay()
        );

    constructor(
        private breakpointObserver: BreakpointObserver,
        public router: Router,
        public headerService: HeaderServiceService,
        private userService: UserService,
        private marketPlaceFilterService: MarketplaceFilterService,
        private marketPlaceService: MarketplaceService,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private trackingService: TrackingService
    ) { }

    ngOnInit(): void {
        this.headerText$ = this.headerService.activeHeaderObservable$;

        this.userService.loggedInObservable$
            .pipe(takeUntil(this.destroy$))
            .subscribe((isLoggedIn) => {
                this.loggedIn = isLoggedIn;
                
                if (!isLoggedIn) {
                    this.headerService.setMenuTabs([]);
                }
                this.cd.markForCheck();
            });

        this.userService.currentUserObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe((user) => {
                if (user && user.userId && user.userId !== 0 && !this.loggedIn) {
                    this.userService.loggedIn = true;
                }
            });

        this.headerService.providersObservable$.subscribe((activeProvider) => {
            // really activeProvider? naming misleading? ->allProviders
            this.activeProvider = activeProvider;
        });
        setTimeout(() => {
            this.login_activated = true;
            this.cd.detectChanges();
        }, 2000);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    //---------Buttons, explicitly default/package private access as these are used in corresponding html-file--------------------

    routeToMarketplace(): void {
        if (this.router.url.includes('/marktplatz')) {
            this.marketPlaceFilterService.resetFilters();
            this.marketPlaceFilterService.changeToProductScreen();
            //this.cd.detectChanges()
        } else if (this.userService.loggedIn) {
            this.headerService.setActiveProvider(this.activeProvider[0], true);
        } else {
            this.router.navigate(['marktplatz']);
        }
        this.cd.detectChanges();
    }

    public clickedLogo(): void {
        this.trackingService.eventEmitter('test', 'test', 'test');
        this.marketPlaceFilterService.setToggleBooleanClearFilter(true);
    }

    public clickedMenu(): void {
        this.marketPlaceService.toggle();
    }
}
